module.exports = __webpack_public_path__ + "static/media/success.749aa5cd.svg";